import { i18n } from '@/plugins/i18n';

const { t } = i18n.global;

const useGetOptionContractStateLabel = (returnValue: number) => {
  if (returnValue > 0) {
    return t('option.contractState.inTheMoney');
  } else if (returnValue < 0) {
    return t('option.contractState.outOfTheMoney');
  } else {
    return t('option.contractState.atTheMoney');
  }
};

export default useGetOptionContractStateLabel;
